import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=bb549c1e&"
import script from "./RadioItem.vue?vue&type=script&lang=js&"
export * from "./RadioItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports